// // import React, { useEffect, useState } from "react";
// import React, { useEffect, useState, useRef } from "react";
// import { jwtDecode } from "jwt-decode";
// import "./GroupChatBoard.css";
// import Navbar from "../common/Navbar";
// import Footer from "../common/Footer";
// import io from "socket.io-client";
// import Sideboard from "./Sideboard"; // Reuse existing Sideboard component
// import CreateGroupModal from "../common/GroupModal";
// import ReactQuill from "react-quill"; // Import React Quill
// import "react-quill/dist/quill.snow.css"; // Import the Quill styles
// import EmojiPicker from "emoji-picker-react"; // Corrected import
// import {
//   Box,
//   Typography,
//   Button,
//   IconButton,
//   Paper,
//   Stack,
//   Input,
// } from "@mui/material";
// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const GroupChatBoard = () => {
//   const [groups, setGroups] = useState([]);
//   const [selectedGroup, setSelectedGroup] = useState(null);
//   const [messages, setMessages] = useState([]);
//   const [newMessage, setNewMessage] = useState(""); // This will hold the HTML content of the message
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [userId, setUserId] = useState(null);
//   const [socket, setSocket] = useState(null);
//   const [employees, setEmployees] = useState([]); // Needed for Sideboard
//   const [isCreateGroupModalOpen, setIsCreateGroupModalOpen] = useState(false);
//   const [showEmojiPicker, setShowEmojiPicker] = useState(false); // State for controlling emoji picker visibility
//   const reactQuillRef = useRef(null); // Create a reference to the ReactQuill component

//   // Initialize Socket Connection
//   useEffect(() => {
//     const socketInstance = io();
//     setSocket(socketInstance);

//     socketInstance.on("newGroupMessage", (messageData) => {
//       if (selectedGroup && messageData.groupId === selectedGroup._id) {
//         setMessages((prev) => [...prev, messageData.message]);
//       }
//     });

//     return () => socketInstance.disconnect();
//   }, [selectedGroup]);

//   // Fetch Groups and Employees
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const token = sessionStorage.getItem("token");
//         const headers = {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         };

//         const groupRes = await fetch(`/api/chat/getallgroups`, {
//           method: "GET",
//           headers,
//         });
//         if (!groupRes.ok) throw new Error("Error fetching groups");
//         const groupData = await groupRes.json();
//         setGroups(groupData.data || []);

//         const empRes = await fetch(`/api/employees/`, {
//           method: "GET",
//           headers,
//         });
//         if (!empRes.ok) throw new Error("Error fetching employees");
//         const empData = await empRes.json();
//         setEmployees(empData);
//       } catch (err) {
//         setError("Error fetching data");
//       }
//     };
//     fetchData();
//   }, []);

//   // Fetch Group Messages
//   const fetchGroupMessages = async (groupId) => {
//     setLoading(true);
//     try {
//       const token = sessionStorage.getItem("token");
//       const response = await fetch(
//         `/api/chat/groupmessages/${groupId}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       if (!response.ok) throw new Error("Error fetching messages");
//       const result = await response.json();
//       setMessages(result.data || []);
//     } catch (err) {
//       setError("Error fetching messages");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Send Message
//   const sendMessage = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const token = sessionStorage.getItem("token");
//       const decodedToken = jwtDecode(token);
//       const senderId = decodedToken.employee.id;

//       const response = await fetch(`/api/chat/sendMessageingroup`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           groupId: selectedGroup._id,
//           content: newMessage, // Send the rich text content
//         }),
//       });

//       const newMsg = await response.json();
//       setMessages((prev) => [...prev, newMsg.data]);
//       socket.emit("sendGroupMessage", newMsg.data);
//       setNewMessage(""); // Clear the editor after sending
//     } catch (err) {
//       setError("Error sending message");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle Emoji Selection
//   // const handleEmojiClick = (emoji) => {
//   //   setNewMessage((prev) => prev + emoji.emoji); // Append the selected emoji to the message
//   //   setShowEmojiPicker(false); // Close the emoji picker after selection
//   // };

//   const handleEmojiClick = (emoji) => {
//     // Check if the Quill editor reference is properly initialized
//     const quill = reactQuillRef.current?.getEditor();
//     if (!quill) return; // If it's not initialized, exit the function

//     // Get the current cursor position
//     const cursorPosition = quill.getSelection()
//       ? quill.getSelection().index
//       : quill.getLength(); // Default to end of the message if no selection

//     // Insert the emoji after the current cursor position
//     quill.insertText(cursorPosition, emoji.emoji);

//     // Move the cursor to the position right after the inserted emoji
//     quill.setSelection(cursorPosition + emoji.emoji.length);

//     setShowEmojiPicker(false); // Close the emoji picker after selection
//   };

//   return (
//     <>
//       <Navbar />
//             <Box sx={{ display: "flex", mt: 7, bgcolor: "#f4f6f8" }}>


//       <div className="main-container">
//         <div className="sideboard-container">
//           <Sideboard
//             employees={employees}
//             groups={groups}
//             onSelectChat={(groupId) => {
//               const group = groups.find((g) => g._id === groupId);
//               setSelectedGroup(group);
//               fetchGroupMessages(groupId);
//             }}
//           />
//         </div>

//         <div className="groupchat-board-container">
//           <h2 className="groupchat-board-title">
//             <strong>
//               <u>Group Chat</u>
//             </strong>
//           </h2>

//           <button
//             onClick={() => setIsCreateGroupModalOpen(true)}
//             className="groupchat-create-button"
//           >
//             Create Group
//           </button>
//           <CreateGroupModal
//             open={isCreateGroupModalOpen}
//             onClose={() => setIsCreateGroupModalOpen(false)}
//           />

//           <div className="groupchat-messages">
//             {messages.length > 0 ? (
//               messages.map((msg) => (
//                 <div
//                   key={msg._id}
//                   className={`groupchat-message ${
//                     msg.senderId === userId ? "my-message" : "other-message"
//                   }`}
//                 >
//                   {msg.senderId !== userId && (
//                     <div className="sender-name">{msg.senderName}</div>
//                   )}
//                   <div className="message-content">
//                     {/* Render rich text content */}
//                     <div dangerouslySetInnerHTML={{ __html: msg.content }} />
//                   </div>
//                   <div className="message-time">
//                     <span>{new Date(msg.createdAt).toLocaleTimeString()}</span>
//                   </div>
//                 </div>
//               ))
//             ) : (
//               <p>No messages yet</p>
//             )}
//           </div>

//           <form onSubmit={sendMessage} className="groupchat-input-form">
//             <div className="quill-editor-container">

//               <ReactQuill
//                 ref={reactQuillRef} // Make sure this is set
//                 value={newMessage}
//                 onChange={setNewMessage}
//                 placeholder="Type a message..."
//                 className="groupchat-quill-editor"
//               />

//               <button
//                 type="button"
//                 className="emoji-button"
//                 onClick={() => setShowEmojiPicker((prev) => !prev)}
//               >
//                 😀
//               </button>
//             </div>

//             {showEmojiPicker && (
//               <div className="emoji-picker-container">
//                 <EmojiPicker onEmojiClick={handleEmojiClick} />
//               </div>
//             )}

//             <button type="submit" className="groupchat-send-button">
//               Send
//             </button>
//           </form>
//         </div>
//       </div>
//       </Box>
//       {/* <Footer /> */}
//     </>
//   );
// };

// export default GroupChatBoard;





import React, { useEffect, useState, useRef } from "react";
import { jwtDecode } from "jwt-decode";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import io from "socket.io-client";
import TextField from '@mui/material/TextField';
import Sideboard from "./Sideboard";
import CreateGroupModal from "../common/GroupModal";
import ReactQuill from "react-quill";
import SearchIcon from "@mui/icons-material/Search";
import "react-quill/dist/quill.snow.css";
import EmojiPicker from "emoji-picker-react";
import SendIcon from "@mui/icons-material/Send";
import { Button } from "@mui/material";
import { BsEmojiSmile } from "react-icons/bs"; // Example emoji icon
import {
  Box,
  Typography,

  Paper,
  IconButton,
} from "@mui/material";
const GroupChatBoard = () => {
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userId, setUserId] = useState(null);
  const [socket, setSocket] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [isCreateGroupModalOpen, setIsCreateGroupModalOpen] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const reactQuillRef = useRef(null);

  // Initialize Socket
  useEffect(() => {
    const socketInstance = io();
    setSocket(socketInstance);

    socketInstance.on("newGroupMessage", (messageData) => {
      if (selectedGroup && messageData.groupId === selectedGroup._id) {
        setMessages((prev) => [...prev, messageData.message]);
      }
    });

    return () => socketInstance.disconnect();
  }, [selectedGroup]);

  // Fetch Groups & Employees
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const headers = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };

        const groupRes = await fetch(`/api/chat/getallgroups`, {
          method: "GET",
          headers,
        });
        const groupData = await groupRes.json();
        setGroups(groupData.data || []);

        const empRes = await fetch(`/api/employees/`, {
          method: "GET",
          headers,
        });
        const empData = await empRes.json();
        // Coerce to an array — some roles get { status, data } or an error object
        // here, which would crash the Sideboard's employees.filter(...).
        setEmployees(Array.isArray(empData) ? empData : empData?.data || []);
      } catch {
        setError("Error fetching data");
      }
    };
    fetchData();
  }, []);

  // Fetch Messages
  const fetchGroupMessages = async (groupId) => {
    setLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `/api/chat/groupmessages/${groupId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const result = await response.json();
      setMessages(result.data || []);
    } catch {
      setError("Error fetching messages");
    } finally {
      setLoading(false);
    }
  };

  // Send Message
  const sendMessage = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = sessionStorage.getItem("token");
      const decodedToken = jwtDecode(token);
      const senderId = decodedToken.employee.id;

      const response = await fetch(`/api/chat/sendMessageingroup`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          groupId: selectedGroup._id,
          content: newMessage,
        }),
      });

      const newMsg = await response.json();
      setMessages((prev) => [...prev, newMsg.data]);
      socket.emit("sendGroupMessage", newMsg.data);
      setNewMessage("");
    } catch {
      setError("Error sending message");
    } finally {
      setLoading(false);
    }
  };

  // Emoji Handler
  const handleEmojiClick = (emoji) => {
    const quill = reactQuillRef.current?.getEditor();
    if (!quill) return;
    const cursorPosition = quill.getSelection()
      ? quill.getSelection().index
      : quill.getLength();
    quill.insertText(cursorPosition, emoji.emoji);
    quill.setSelection(cursorPosition + emoji.emoji.length);
    setShowEmojiPicker(false);
  };

  return (
    <>
      <Box sx={{ display: "flex", bgcolor: "#f4f6f8", height: "calc(100vh - 64px)", p: 1, mr: 1 }}>
        {/* Sideboard */}
        <Paper
          sx={{
            flex: "0 0 25%",     // ✅ fixed 25% width
            maxWidth: "25%",
            // borderRight: "1px solid #e0e0e0",
            borderRadius: 0,
            // boxShadow: "2px 0 8px rgba(0,0,0,0.05)",
            overflowY: "auto",
            borderRadius: "16px", // same as the rest
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)", // smooth shadow
            bgcolor: "#ffffff", // white like cards
            mr: 1,
          }}
        >
          <Sideboard
            employees={employees}
            groups={groups}
            onSelectChat={(groupId) => {
              const group = groups.find((g) => g._id === groupId);
              setSelectedGroup(group);
              fetchGroupMessages(groupId);
            }}
          />
        </Paper>




        {/* Main Chat */}
        <Box sx={{
          flex: "0 0 75%", maxWidth: "75%", display: "flex", flexDirection: "column",
        }}>
          <Paper
            elevation={0}
            sx={{
              p: 2,
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)", // smooth shadow
              bgcolor: "#ffffff", // card-like white background
           
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {/* Left: Heading */}
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", textDecoration: "underline" }}
              >
                Group Chat
              </Typography>

              {/* Right: Button */}
       <Button
  variant="contained"
  onClick={() => setIsCreateGroupModalOpen(true)}
  sx={{
    width: 200,
    bgcolor: "#1E40AF",
    textTransform: "none",
    borderRadius: "8px",
    boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
    position: "relative",
    overflow: "hidden",
    transition: "all 0.3s ease",
    "&:hover": {
      bgcolor: "#163580",
      boxShadow: "0 6px 14px rgba(0,0,0,0.18)",
    },
  }}
  onMouseOver={(e) => {
    const wave = e.currentTarget.querySelector(".hover-wave");
    if (wave) wave.style.left = "100%";
  }}
  onMouseOut={(e) => {
    const wave = e.currentTarget.querySelector(".hover-wave");
    if (wave) wave.style.left = "-100%";
  }}
>
  Create Group
  <span
    className="hover-wave"
    style={{
      position: "absolute",
      top: 0,
      left: "-100%",
      width: "100%",
      height: "100%",
      background: "rgba(255,255,255,0.2)",
      transform: "skewX(-20deg)",
      transition: "left 0.6s ease-in-out",
      pointerEvents: "none",
    }}
  />
</Button>

            </Box>
          </Paper>

          {/* Modal */}
          <CreateGroupModal
            open={isCreateGroupModalOpen}
            onClose={() => setIsCreateGroupModalOpen(false)}
          />


          {/* Messages */}
       <Box
                sx={{
                  flex: 1,
                  bgcolor: "white",
                  mt:1,
                  p: 3,
                  overflowY: "auto",
                  "&::-webkit-scrollbar": { width: "6px" },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#c1c1c1",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": { background: "#a8a8a8" },
                     borderRadius: "12px", // same as the rest
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)", // smooth shadow
              bgcolor: "#ffffff", // white like cards
                }}
              >
            {messages.length > 0 ? (
              messages.map((msg) => (
                <Box
                  key={msg._id}
                  sx={{
                    display: "flex",
                    justifyContent: msg.senderId === userId ? "flex-end" : "flex-start",
                    mb: 1.5,
                  }}
                >
                  <Paper
                    elevation={1}
                    sx={{
                      p: 2,
                      bgcolor: msg.senderId === userId ? "#d1f7c4" : "#f9f9f9", // ✅ match colors
                      borderRadius: 3,
                      maxWidth: "70%",
                      overflow: "hidden",
                    }}
                  >
                    {/* Sender Name (only for others) */}
                    {msg.senderId !== userId && (
                      <Typography
                        variant="subtitle2"
                        sx={{ mb: 0.5, fontWeight: 600, color: "#64748B" }}
                      >
                        {msg.senderName}
                      </Typography>
                    )}

                    {/* Message Body */}
                    <Typography
                      variant="body1"
                      sx={{ fontSize: 14 }}
                      dangerouslySetInnerHTML={{ __html: msg.content }}
                    />

                    {/* Timestamp */}
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ display: "block", mt: 1 }}
                    >
                      {new Date(msg.createdAt).toLocaleTimeString()}
                    </Typography>
                  </Paper>
                </Box>
              ))
            ) : (
<Box
  sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    p: 3,
    mt:10,
    color: "text.secondary",
  }}
>
  {/* Icon instead of image */}
  <SearchIcon sx={{ fontSize: 64, mb: 2, color: "grey.500" }} />

  {/* Text */}
  <Typography variant="h6" fontWeight={600}>
    No Group  messages found
  </Typography>
  <Typography variant="body2">
    Start New Group conversation.
  </Typography>
</Box>
            )}
        </Box>


          {/* Input Form */}
<Box
  component="form"
  onSubmit={sendMessage}
  sx={{
    p: 2,
    display: "flex",
    flexDirection: "column", // so emoji picker can sit below if needed
    gap: 1,
    mt: 0.5,
    borderRadius: "12px", // same as private
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)", // smooth shadow
    bgcolor: "#ffffff",
    position: "relative", // required for emoji picker absolute positioning
  }}
>
  {/* === Row: Input + Emoji + Send === */}
  <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>


        {/* Emoji Button */}
    <Button
      onClick={() => setShowEmojiPicker((prev) => !prev)}
      sx={{
        minWidth: "40px",
        height: "40px",
        // bgcolor: "#f5f5f5",
        borderRadius: "8px",
        // boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        "&:hover": { bgcolor: "#eaeaea" },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 0,
        mr: 0.5,
        width:"20px",
      }}
    >
      <BsEmojiSmile size={20} />
    </Button>
    {/* Message Input */}
    <TextField
      variant="outlined"
      size="small"
      placeholder="Type a message..."
      value={newMessage}
      onChange={(e) => setNewMessage(e.target.value)}
      sx={{
        flex: 1,
        mr: 0.5,
        bgcolor: "white",
        borderRadius: "8px",
        "& .MuiOutlinedInput-root": {
          borderRadius: "8px",
        },
      }}
    />



    {/* Send Button */}
    <button
      type="submit"
      disabled={loading || !newMessage}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        borderRadius: "50px",
        padding: "6px 14px",
        border: "none",
        cursor: "pointer",
        background: "linear-gradient(to right, #1E40AF, #5C85FF)",
        color: "white",
        fontSize: "16px",
        fontWeight: 500,
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        textTransform: "none",
        width: "auto",
                    marginTop: "-1px",

        height: "40px",
        flexShrink: 0,
      }}
      onMouseOver={(e) =>
        (e.currentTarget.style.background =
          "linear-gradient(to right, #152D85, #1E40AF)")
      }
      onMouseOut={(e) =>
        (e.currentTarget.style.background =
          "linear-gradient(to right, #1E40AF, #5C85FF)")
      }
    >
      <span>Send</span>
      <SendIcon style={{ fontSize: "18px" }} />
    </button>
  </Box>

  {/* Emoji Picker */}
  {showEmojiPicker && (
    <Box
      sx={{
        position: "absolute",
        bottom: 60,
        right: 20,
        zIndex: 10,
      }}
    >
      <EmojiPicker onEmojiClick={handleEmojiClick} />
    </Box>
  )}
</Box>



        </Box>
      </Box>
      {/* <Footer /> */}
    </>
  );
};

export default GroupChatBoard;

